const H5 = () => import('@/views/main/h5/accessLink/AccessLink.vue')
export default {
  path: '/main/h5/link',
  name: 'H5',
  component: H5,
  children: []
}
